// extracted by mini-css-extract-plugin
export default {"container":"style__container___SmTJc","image":"style__image___vhSE5"};